var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.entries && _vm.entries.length > 0) || _vm.trending)?_c('div',[(_vm.key === 'items/type-counts')?_c('BrowseInfoCardSection',{attrs:{"section":_vm.contentCardSection}}):(_vm.trending)?_c('ItemTrendingItems'):_c('ContentCardSection',{staticClass:"mb-5",attrs:{"section":_vm.contentCardSection}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }